import axios from 'axios'
import env from './config/env'
import Echo from 'laravel-echo'

window.axios = axios
window.axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token')

window._ = require('lodash')

window.Pusher = require('pusher-js')

// Reverb implementa o protocolo Pusher, por isso broadcaster='pusher' funciona.
// (laravel-echo 1.16+ tem broadcaster='reverb' nativo. Aqui estamos no 1.15.)
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: env.wsKey,
    cluster: 'mt1', // exigido pelo pusher-js mas ignorado pelo Reverb
    wsHost: env.wsHost,
    wsPort: env.wsPort,
    wssPort: env.wsPort,
    forceTLS: env.wsForceTLS,
    encrypted: env.wsForceTLS,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: env.normalURL + '/broadcasting/auth',
    auth: {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    },
})

window.Echo.connector.pusher.connection.bind('connected', () => {
    console.log('Conectado ao Reverb com sucesso')
})

window.Echo.connector.pusher.connection.bind('error', (err) => {
    console.error('Erro na conexão Reverb:', err)
})

window.$ = window.jQuery = require('jquery')
require('bootstrap')
